/**
 * WooCommerce side cart drawer.
 * No ES module syntax — this file is concatenated into one bundle by Gulp.
 */
function initCart() {
    var overlay  = document.getElementById('cartOverlay');
    var drawer   = document.getElementById('cartDrawer');
    var closeBtn = document.getElementById('cartClose');

    if ( ! drawer ) return;

    function openCart() {
        drawer.classList.add('on');
        if ( overlay ) overlay.classList.add('on');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
    }

    function closeCart() {
        drawer.classList.remove('on');
        if ( overlay ) overlay.classList.remove('on');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
    }

    if ( closeBtn ) closeBtn.addEventListener('click', closeCart);
    if ( overlay )  overlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', function(e) {
        if ( e.key === 'Escape' && drawer.classList.contains('on') ) closeCart();
    });

    // Global click delegation for data-cart-toggle and data-cart-close
    document.addEventListener('click', function(e) {
        var toggle = e.target.closest('[data-cart-toggle]');
        if ( toggle ) { e.preventDefault(); openCart(); return; }

        var close = e.target.closest('[data-cart-close]');
        if ( close ) { e.preventDefault(); closeCart(); return; }
    });

    // WooCommerce AJAX — apply fragments then open cart drawer
    if ( typeof jQuery !== 'undefined' ) {
        jQuery(document.body).on('added_to_cart', function(e, fragments) {
            if ( fragments ) {
                jQuery.each(fragments, function(selector, html) {
                    jQuery(selector).replaceWith(html);
                });
            }
            flashCartIcon();
            openCart();
        });
    }

    // Add-to-cart via data-add-to-cart buttons (non-WC AJAX fallback)
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-add-to-cart]');
        if ( ! btn ) return;
        if ( btn.tagName === 'A' ) return; // let WC handle native add-to-cart links

        e.preventDefault();
        e.stopPropagation();

        var productId = btn.dataset.addToCart;
        if ( ! productId || typeof reshoppitCart === 'undefined' ) return;

        var body = new URLSearchParams({
            action:     'woocommerce_ajax_add_to_cart',
            product_id: productId,
            quantity:   1,
            nonce:      reshoppitCart.nonce
        });

        fetch(reshoppitCart.ajaxUrl, {
            method:  'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body:    body.toString()
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
            if ( typeof jQuery !== 'undefined' && data.fragments ) {
                jQuery(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash]);
            } else {
                flashCartIcon();
                openCart();
            }
        })
        .catch(function() {
            if ( typeof reshoppitCart !== 'undefined' ) {
                window.location.href = reshoppitCart.cartUrl;
            }
        });
    });

    function flashCartIcon() {
        document.querySelectorAll('[data-cart-toggle]').forEach(function(el) {
            el.classList.remove('flash');
            void el.offsetWidth;
            el.classList.add('flash');
        });
    }
}
